"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _DataRow = _interopRequireDefault(require("./DataRow"));

var _utils = require("./utils");

var _DraggableWrapper = _interopRequireDefault(require("./DraggableWrapper"));

var _Provider = require("./Provider");

var _joinClassnames = _interopRequireDefault(require("../../utils/joinClassnames"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function GroupHeaderRow(props) {
  var _props$GroupHeader = props.GroupHeader,
      GroupHeader = _props$GroupHeader === void 0 ? function () {
    return _react.default.createElement(_react.default.Fragment, null);
  } : _props$GroupHeader,
      columns = props.columns,
      _props$getGroupHeader = props.getGroupHeaderAttrs,
      getGroupHeaderAttrs = _props$getGroupHeader === void 0 ? function () {} : _props$getGroupHeader,
      _props$getRowAttrs = props.getRowAttrs,
      getRowAttrs = _props$getRowAttrs === void 0 ? function () {} : _props$getRowAttrs,
      groupData = props.groupData,
      groupId = props.groupId,
      provided = props.provided;
  var customRowAttrs = getRowAttrs(groupData, {
    isGroupHeaderRow: true
  });
  return _react.default.createElement("tr", _extends({
    ref: provided && provided.innerRef
  }, customRowAttrs, {
    className: (0, _joinClassnames.default)('group-header-row', customRowAttrs && customRowAttrs.className)
  }, provided ? _objectSpread({}, provided.draggableProps, {}, provided.dragHandleProps) : {}), _react.default.createElement("th", _extends({
    id: groupId,
    colSpan: columns.length,
    scope: "colgroup"
  }, getGroupHeaderAttrs(groupData)), _react.default.createElement("div", null, _react.default.createElement(GroupHeader, {
    groupData: groupData
  }))));
}

function DroppableWrapper(_ref) {
  var children = _ref.children,
      onDragEnd = _ref.onDragEnd,
      onBeforeDragStart = _ref.onBeforeDragStart;

  var _useContext = (0, _react.useContext)(_Provider.TableContext),
      isDnDEnabled = _useContext.isDnDEnabled,
      contextId = _useContext.contextId;

  if (!isDnDEnabled) return children();
  return _react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd,
    onBeforeDragStart: onBeforeDragStart
  }, _react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable-".concat(contextId)
  }, children));
}

function Body(props) {
  var columns = props.columns,
      data = props.data,
      _props$getRowKey = props.getRowKey,
      getRowKey = _props$getRowKey === void 0 ? _utils.defaultGetRowKey : _props$getRowKey,
      kind = props.kind,
      variant = props.variant,
      onDragEndProp = props.onDragEnd,
      getRowAttrs = props.getRowAttrs;
  var positions = [];

  var _useContext2 = (0, _react.useContext)(_Provider.TableContext),
      setIsDragging = _useContext2.setIsDragging,
      contextId = _useContext2.contextId,
      isDnDEnabled = _useContext2.isDnDEnabled,
      setHasDragHandlers = _useContext2.setHasDragHandlers;

  var onDragEnd = (0, _react.useCallback)(function (_ref2) {
    var source = _ref2.source,
        destination = _ref2.destination;
    setIsDragging(false);
    if (!destination || !onDragEndProp) return;

    var _positions$source$ind = _slicedToArray(positions[source.index], 2),
        fromGroup = _positions$source$ind[0],
        fromIndex = _positions$source$ind[1];

    var _positions$destinatio = _slicedToArray(positions[destination.index], 2),
        toGroup = _positions$destinatio[0],
        toIndex = _positions$destinatio[1];

    var hasGroups = fromIndex !== undefined || toIndex !== undefined;
    var fixedGroup = toGroup;
    var fixedIndex = toIndex;

    if (!hasGroups) {
      onDragEndProp(fromGroup, toGroup);
      return;
    } // when dropping in a header place


    if (toIndex === undefined) {
      if (toGroup === 0) return;

      if (fromGroup >= toGroup) {
        // it is actually aiming to the last position of previous group
        var _positions = _slicedToArray(positions[destination.index - 1], 2);

        fixedGroup = _positions[0];
        fixedIndex = _positions[1];
        fixedIndex += 1;
      } else {
        // aiming for the first position of the group
        fixedIndex = 0;
      }
    } else if (fromGroup < toGroup) fixedIndex += 1;

    onDragEndProp([fromGroup, fromIndex], [fixedGroup, fixedIndex]);
  }, [setIsDragging, onDragEndProp, positions]);
  var onBeforeDragStart = (0, _react.useCallback)(function () {
    setIsDragging(true);
  }, [setIsDragging]);
  (0, _react.useEffect)(function () {
    if (!isDnDEnabled) return;
    var dragHandlers = document.querySelectorAll("[data-drag-handle-context-id=".concat(contextId, "]"));
    if (dragHandlers.length > 0) setHasDragHandlers(true);
  }, [contextId, isDnDEnabled, setHasDragHandlers]);
  return _react.default.createElement(DroppableWrapper, {
    onDragEnd: onDragEnd,
    onBeforeDragStart: onBeforeDragStart
  }, function (droppableProvided) {
    var dndIndex = -1;
    return _react.default.createElement("tbody", _extends({
      ref: droppableProvided && droppableProvided.innerRef
    }, droppableProvided ? droppableProvided.droppableProps : {}), data.map(function (dataObj, dataIndex) {
      dndIndex += 1;
      positions[dndIndex] = [dataIndex];

      if ((0, _utils.isGroupData)(dataObj, props)) {
        var groupId = getRowKey(dataObj, {
          isGroupHeaderRow: true
        });
        return _react.default.createElement(_react.default.Fragment, {
          key: groupId
        }, _react.default.createElement(_DraggableWrapper.default, {
          id: groupId,
          dndIndex: dndIndex,
          isDragDisabled: true
        }, function (provided) {
          return _react.default.createElement(GroupHeaderRow, _extends({
            groupData: dataObj,
            groupId: groupId,
            provided: provided,
            getRowAttrs: getRowAttrs
          }, props));
        }), (0, _get.default)(dataObj, props.rowDataPath).map(function (rowData, rowIndex) {
          dndIndex += 1;
          positions[dndIndex] = [dataIndex, rowIndex];
          var rowKey = getRowKey(rowData, {
            isGroupHeaderRow: false
          });
          return _react.default.createElement(_DraggableWrapper.default, {
            key: rowKey,
            id: rowKey || dndIndex.toString(),
            dndIndex: dndIndex
          }, function (provided) {
            return _react.default.createElement(_DataRow.default, {
              className: "group-data-row",
              columns: columns,
              groupData: dataObj,
              groupId: groupId,
              key: rowKey,
              kind: kind,
              rowData: rowData,
              rowIndex: rowIndex,
              variant: variant,
              provided: provided,
              getRowAttrs: getRowAttrs
            });
          });
        }));
      }

      var rowKey = getRowKey(dataObj, {
        isGroupHeaderRow: false
      });
      return _react.default.createElement(_DraggableWrapper.default, {
        key: rowKey,
        id: rowKey || dndIndex.toString(),
        dndIndex: dndIndex
      }, function (provided) {
        return _react.default.createElement(_DataRow.default, {
          columns: columns,
          kind: kind,
          rowData: dataObj,
          rowIndex: dataIndex,
          variant: variant,
          provided: provided,
          getRowAttrs: getRowAttrs
        });
      });
    }), droppableProvided && droppableProvided.placeholder);
  });
}

var _default = Body;
exports.default = _default;